import { useMutation, useQueryClient } from '@tanstack/react-query';
import { clientSaveEstateStatusFirmTemplate, useGraphqlClient } from '../../graphql';
import { scorecardKeys } from '../../Scorecard/queryKeys';
import { estateStatusKeys } from '../queryKeys';
import { SaveEstateStatusFirmTemplateInput } from '../types';

export function useSaveEstateStatusFirmTemplate(firmID: string | undefined | null) {
  const gqlClient = useGraphqlClient();
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (input: SaveEstateStatusFirmTemplateInput) => {
      if (!firmID) {
        return Promise.reject(new Error('Firm ID is required to save the Estate Status template.'));
      }

      return clientSaveEstateStatusFirmTemplate(gqlClient, { firmID, ...input });
    },
    {
      onSuccess: (savedTemplate: Awaited<ReturnType<typeof clientSaveEstateStatusFirmTemplate>> | undefined) => {
        if (!firmID) return;

        queryClient.setQueryData(estateStatusKeys.firmTemplate(firmID), savedTemplate);
        void queryClient.invalidateQueries({ queryKey: estateStatusKeys.base });
        // Firm templates can seed any household without a customized checklist.
        void queryClient.invalidateQueries({ queryKey: scorecardKeys.base });
      },
    }
  );

  return { saveEstateStatusFirmTemplateMutation: mutation };
}
